import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=1f0c8d89&scoped=true&"
import script from "./ConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=1f0c8d89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c8d89",
  null
  
)

export default component.exports